import { Component, createRef } from 'react';

import './input-box.css';

export class InputBox extends Component {
   constructor(props) {
      super(props);
      this.valueRef = createRef();
   }

   componentDidMount() {
      if (this.props.focusOnInit) {
         this.valueRef.current.focus();
      }
   }

   updateValue(value) {
      const onValueChange = this.props.onValueChange;
      if (onValueChange)
         onValueChange(value);

      this.setState({value: value});
   }

   keyPressed(e) {
      if (e.key === "Enter") {
         this.buttonClicked();
      }
   }

   buttonClicked() {
      if (this.props.disabled)
         return;

      const onButtonClicked = this.props.onButtonClicked;
      if (onButtonClicked)
         onButtonClicked();
   }

   render() {
      return (
         <div className="input-box">
            <input className="input-box-value"
               autoComplete="off"
               ref={this.valueRef}
               type={this.props.isPassword ? "password" : "text"}
               value={this.props.value}
               onInput={e => this.updateValue(e.target.value)}
               onKeyUp={e => this.keyPressed(e)}
               maxLength={this.props.maxLength}
               placeholder={this.props.placeholder} />

            <button className="input-box-button"
               disabled={this.props.disabled}
               onClick={() => this.buttonClicked()}>

               <img className="input-box-button-icon" 
                  src="svg/send.svg" 
                  alt="" />
            </button>
         </div>
      )
   }
}